import { render } from "./SignupForm.vue?vue&type=template&id=00dd4672&ts=true"
import script from "./SignupForm.vue?vue&type=script&lang=ts"
export * from "./SignupForm.vue?vue&type=script&lang=ts"

import "./SignupForm.vue?vue&type=style&index=0&id=00dd4672&lang=scss&scope=true"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__